






import { computed, defineComponent } from '@vue/composition-api'
import CloudFrontUtil from '@/util/aws/CloudFrontUtil'

export default defineComponent({
  name: 'HomeCustomIcon',
  props: {
    /**
     * Homeアイコンのパス
     */
    iconPath: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    /** ロゴのパス */
    const logoPath = computed(() => CloudFrontUtil.getSignedUrl(props.iconPath))

    return {
      logoPath,
    }
  },
})
